import { array, number, object, string, z } from "zod";

const InputValueDefaultObj = object({
  uid: number(),
  name: string(),
});
const ZodiacInputValue = object({
  uid: string(),
  name: string(),
});
const CountryInputValue = object({
  country: string(),
  uid: number(),
});

const AppearanceTypeInputValue = object({
  uid: string(),
  name: string(),
});

export const InputValuesResSchema = object({
  forms: object({
    appearanceType: array(AppearanceTypeInputValue),
    eye: array(InputValueDefaultObj),
    country: array(CountryInputValue),
    hair: array(InputValueDefaultObj),
    zodiac: array(ZodiacInputValue),
    drinker: array(InputValueDefaultObj),
    english: array(InputValueDefaultObj),
    religion: array(InputValueDefaultObj),
  }),
});
export type InputValuesResDTO = z.infer<typeof InputValuesResSchema>;

export const CityDTO = object({
  name: string(),
  uid: number(),
});

export const CitySearchResSchema = object({
  forms: array(CityDTO),
});
export type CitySearchResDTO = z.infer<typeof CitySearchResSchema>;
